(function () {
    'use strict';

    angular
        .module('planInitiativeEditModule', [
            'planInitiativeModule'
        ]);
})();
